import { Skeleton } from '@/components/ui';

export default function GetDirectionsSkeleton(): React.ReactNode {
  return (
    <div className='mt-2 rounded-2xl border border-gray-200 p-4'>
      <Skeleton className='h-[250px] w-full rounded-lg bg-gray-300' />
      <div className='mt-4 flex items-center justify-between'>
        <div className='flex flex-col gap-2'>
          <Skeleton className='h-6 w-54 rounded-lg bg-gray-300' />
          <Skeleton className='h-6 w-54 rounded-lg bg-gray-300' />
        </div>
        <div>
          <Skeleton className='h-10 w-32 rounded-lg bg-gray-300' />
        </div>
      </div>
    </div>
  );
}
